import React from 'react';
import {ITabContent} from 'interfaces/dealerLocator';

export function TabContent(props: ITabContent) {
    return (
        <div
          style={{width: '100%'}}
          role="tabpanel"
          hidden={props.value !== props.index}
          id={`wrapped-tabpanel-${props.index}`}
          aria-labelledby={`wrapped-tab-${props.index}`}
          >
              <>{props.children}</>
        </div>
  );
}
